import { Box, Button } from '@mui/material'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { SubscriptionModel } from 'types'
import SubscriptionDataGrid from 'components/SubscriptionDataGrid'

export default function SubscriptionsPage() {
  const subscriptions = useLoaderData() as SubscriptionModel[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Abonnements">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 64px)',
          padding: '1rem',
        }}
      >
        <Button
          variant="contained"
          sx={{ mb: '1rem', alignSelf: 'flex-start' }}
          onClick={() => navigate('/subscription')}
        >
          Créer un abonnement
        </Button>
        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <SubscriptionDataGrid subscriptions={subscriptions} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
